import axios from "axios"
import { environment } from "../environments/environment"

export const getActiveMenuModules = async () => {
  try {
    const response = await axios.get(environment.getActiveModulesMenu);
    return response; // Axios ya convierte la respuesta a JSON si es necesario
  } catch (error) {
    console.error("Error al obtener los módulos activos:", error);
    throw error; // Lanza el error para que sea manejado por quien llame esta función
  }
};
